module.exports = __webpack_public_path__ + "img/sh.5e5280da.png";